var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessingFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offices_Fill",
    "data-name": "Offices Fill",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Processing"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base-2",
    "data-name": "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "transfer_3_",
    "data-name": "transfer (3)",
    d: "M9,18a9,9,0,1,1,9-9A9.01,9.01,0,0,1,9,18Zm3.84-6.563H5.53l.845-.845a.643.643,0,0,0-.909-.909L3.523,11.625a.643.643,0,0,0,0,.909l1.942,1.942a.643.643,0,1,0,.909-.909l-.845-.845h7.31a.643.643,0,0,0,0-1.286Zm-.305-7.914a.643.643,0,1,0-.909.909l.845.845h-7.7a.643.643,0,0,0,0,1.286h7.7l-.845.845a.643.643,0,1,0,.909.909l1.942-1.942a.643.643,0,0,0,0-.909Z",
    transform: "translate(82 231)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingFill);
export default __webpack_public_path__ + "static/media/processingFill.49a6b7eab75a6d570b416b38da591cc5.svg";
export { ForwardRef as ReactComponent };